export * from './forTesting.tmpl';
export * from './TefComs4p';
export * from './tefComsCancelButton.tmpl';
